<template>
  <div class="container">
    <van-cell-group inset>
      <van-form @submit="login">
        <van-field v-model="loginForm.moaid" readonly label="鉴定记录号" />
        <van-field v-model="loginForm.appraiserName" label="用户名" placeholder="请输入用户名" />
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit">登陆</van-button>
        </div>
      </van-form>
    </van-cell-group>
  </div>
</template>

<script>
import { Toast } from 'vant'
import jsCookies from 'js-cookie'
import {
  apiAppraiserLogin,
  appraiser_login
} from "@/common/api/appraisal.js";

// 业务来源枚举
const sourceMapper = {
  // 默认是人工鉴定订单鉴别
  'manually': {
    pathName: 'orderDetail',
    url: ''
  },
  // 无法鉴定转人工订单
  'cantAppriseToManual': {
    pathName: 'cantAppriseToManualOrderDetail', // todo @宋耀先
    url: ''
  },
}

export default {
  name: 'appraiserLogin',
  data () {
    return {
      //登录表单
      loginForm: {
        appraiserName: "",  //鉴定师姓名
        moaid: this.$route.params.moaid  //鉴定单ID
      },
      canClick: false,
      source: ''
    }
  },
  created () {
    const { query: { source = 'manually' } = { source: '' } } = this.$route
    this.source = source
  },
  methods: {
    //鉴定师点击登录
    login () {
      const { appraiserName, moaid } = this.loginForm
      if (appraiserName && moaid) {
        // 转人工2期
        if (this.source === 'cantAppriseToManual') {
          appraiser_login({
            ...this.loginForm,
            oaid: this.loginForm.moaid,
          }).then(res => {
            if (res.errorCode === 0) {
              this.goDetail(res.token)
            }
          })
        } else {
          apiAppraiserLogin({ ...this.loginForm }).then((res) => {
            if (res.errorCode === 0) {
              this.goDetail(res.token)
            }
          })
        }
      } else {
        Toast.fail({ duration:1000,message:'请输入用户名' })
      }
    },

    goDetail (token) {
      Toast.success({ message: '登录成功' })
      jsCookies.set('appraiserToken', token)
      const pathName = (sourceMapper[this.source || 'manually'] || {}).pathName
      console.log('pathName ===', pathName)
      if (!pathName) return Toast.fail({duration:500,message:'业务来源获取失败，请联系开发者'})
      console.log('pathName:', pathName)
      this.$router.push({
        name: pathName,
        query: {
          moaid: this.loginForm.moaid
        }
      });
    }
  },
}
</script>
<style scoped>
.container {
  display: flex;
  min-height: 100vh;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  background-color: #f7f8fa;
}
.login-form {
  width: 80%;
  height: 20%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  padding: 50px;
}
.appraiser-name {
  width: 100%;
  height: 6vh;
}
.login-btn {
  margin-top: 40px;
  width: 100%;
  height: 6vh;
}
</style>